export default __webpack_public_path__ + "static/media/partner-dw-consulting.70554da0.webp";